module.exports = __webpack_public_path__ + "static/g-play-e1197275c0d293231bfa7d54b4ae0b97.png";